export const environment: any = {
    production: true,
    enableDebug: true,
    isDebugMode: "true",
    oem: "opel",
    defaultLangCode: "en_GB",
    defaultLangName: "English GBR",
    cookieName: "myAppLocaleCookie",
    instrumentationKey: "88ea5c65-6114-47d1-9040-d426a5533328"
};